import { render, staticRenderFns } from "./BeitrageUGebuhren.vue?vue&type=template&id=2088b1be&scoped=true&"
import script from "./BeitrageUGebuhren.vue?vue&type=script&lang=js&"
export * from "./BeitrageUGebuhren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088b1be",
  null
  
)

export default component.exports